export const SSO_DOMAIN = 'sso.exp1.org'
